import React from 'react'
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY, STRIPE_SECRET_KEY } from '../../utils/config/constants';
import CardAdd from './CardAdd';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const CardComponect = ({finalToken}) => {
    const gettoken =(item)=>{
     finalToken(item)
    }
  return (
    <Elements stripe={stripePromise}>
    <CardAdd getToken={gettoken}  />
  </Elements>
  )
}

export default CardComponect


// WEBPACK FOOTER //
// ./src/components/Booking/CardComponect.js